import { Outlet } from 'react-router-dom';

const LoginRoute = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <Outlet />
    </div>
  );
};

export default LoginRoute; 